import React , {useEffect ,useState } from 'react'
import "./orderPage.css"
import BillTile from "../checkout-page/components/bill-details/BillTile.jsx"
import { MdVerified } from 'react-icons/md';
import { calculateOriginalPrice } from '../../functions/mini_func'; 
import FlashpeImg from "../../assets/images/splash_image.jpg";
import html2canvas from 'html2canvas';
import {AiOutlineShareAlt} from "react-icons/ai";
import UserQR from './UserQR';
import { db } from '../../config/firebase_config';
import { ref , get } from 'firebase/database';
import { LoadingSpinner } from '../../components/mini-components/mini-components';
import { useLocation, useNavigate } from 'react-router-dom';

const OrderPage = () => {
 
 
  const [orderInfo, setOrderInfo] = useState(null);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const orderID = queryParams.get('orderID');


  useEffect(() => {

   const  fetchData = async() => {
      const dbRestRef = ref(db , `ConfirmPayment/${orderID}` );
      const orderSnap = await get(dbRestRef);
        if (orderSnap.exists()) {
          const data = orderSnap.val();
          console.log( "<--- order comp data  --->" , data );
          setOrderInfo(data);
        }
   }
   
   fetchData();


   return () => {
    // navigate(-1);
   }

  }, [])
  
    
  const captureFullPageScreenshot = () => {
    const scrollY = window.scrollY;
  
    // Hide the element with "javascript" text temporarily
    const javascriptTextElement = document.getElementById('your-javascript-text-element-id');
    if (javascriptTextElement) {
      javascriptTextElement.style.display = 'none';
    }
  
    html2canvas(document.body, { scrollY: -scrollY }).then(canvas => {
      // Restore the visibility of the "javascript" text element
      if (javascriptTextElement) {
        javascriptTextElement.style.display = '';
      }
  
      const screenshot = canvas.toDataURL('image/png');
  
      // Create a temporary link element for downloading
      const link = document.createElement('a');
      link.href = screenshot;
      link.download = `Flashpe-food-order-${orderInfo.orderId}.png`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    });
  };
  
  const shareFullPageScreenshot = () => {
    const scrollY = window.scrollY;
    html2canvas(document.body, { scrollY: -scrollY }).then(canvas => {
      const screenshot = canvas.toDataURL('image/png');
  
      // Convert the screenshot data to a Blob
      const blob = dataURLtoBlob(screenshot);
  
      // Create a file from the Blob
      const file = new File([blob], 'screenshot.png', { type: 'image/png' });
  
      // Use the Web Share API to share the image file
      if (navigator.share) {
        navigator.share({
          files: [file],
          title: 'Screenshot',
          text: 'Order Food from Flashpe and get exclusive offers',
        })
          .then(() => console.log('Screenshot shared successfully.'))
          .catch(error => console.log('Error sharing screenshot:', error));
      } else {
        console.log('Web Share API is not supported in this browser.');
      }
    });
  };
  

  const dataURLtoBlob = (dataURL) => {
    const parts = dataURL.split(';base64,');
    const contentType = parts[0].split(':')[1];
    const byteCharacters = atob(parts[1]);
    const byteArrays = [];
  
    for (let offset = 0; offset < byteCharacters.length; offset += 512) {
      const slice = byteCharacters.slice(offset, offset + 512);
      const byteNumbers = new Array(slice.length);
  
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
  
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
  
    return new Blob(byteArrays, { type: contentType });
  };
    

  const OrderTile = ({name , price , quantity , isLast , discount}) => {
    return  <>
       <div className='order-tile'>
          <div className='order-name-info'>{name}</div>
          <span> {"\u{20B9}\t"} {calculateOriginalPrice(discount , price )} </span>
          <h5>&times; {quantity}</h5>
      </div>
      {
        !isLast  &&
      <div className='dotted-border' ></div>
      }
      </>
  }

  return orderInfo === null 
   ? <div className='order-loading'>
       <LoadingSpinner/>
       <p>Please wait ... <br/>  while we fetch your order Data</p>
    </div>
   : (
     <div className='order-page-container gradient-background'id='order-page-id' >
     <div className='hide-text'></div>
      <div className='order-main-section' >
        <div className='order-name' >
            <h3>Order Details</h3>
            <img src={FlashpeImg} alt="" width={"60px"} height={"60px"} />
        </div>
        <div className='order-title'>
          <div>
            <p>Order Id : {orderInfo.orderId}</p>
            <p className='order-time' > {orderInfo.time} <span>{orderInfo.date}</span></p>
          </div>
          <div className='order-verify'> <MdVerified/></div>
        </div>
        <div className='share-order' >
            <button className='print-order' onClick={captureFullPageScreenshot} > Download Order </button>
               <AiOutlineShareAlt className='share-btn' onClick={shareFullPageScreenshot} />
        </div>
      </div>
      <div className='order-rest-section order-item-container' >
          <h4 className='order-title-name'>Restaurant Information</h4>
           <div className='rest-name'>{orderInfo.restName}</div>
          <p>Phone Number : <span>{orderInfo.restOwnerNo}</span></p>
          {/* <p>GSTIN : <span>{orderInfo.gstNo}</span></p> */}
          <p>Address : <span>{orderInfo.pickUpApartmentAddress}</span></p>
      </div>
      <div className='order-user-section order-item-container'>
          <h4 className='order-title-name'>User Information</h4>
          <UserQR phoneNo={orderInfo.phone} />
          <p>Phone Number : <span>{orderInfo.phone}</span></p>
          <p>Name : <span>{orderInfo.name}</span></p>
      </div>
      <div className='order-items-section order-item-container' >
        <h4 className='order-title-name'>Order Items</h4>
        {
          orderInfo.food.map((item , index) => {
            return <OrderTile key={index}  name={item.productName} quantity={item.quantity} isLast={ orderInfo.food.length -1 == index } price={item.price} discount={item.discount}  />
          } )
        }
      </div>
      <div className='order-bill-section order-item-container' >
        <h4 className='order-title-name'>Bill Details</h4>
        <BillTile name={"Sub total"} amount={orderInfo.foodTotal}  />
        <BillTile name={"GST (5%)"} amount={orderInfo.foodGst} />
        <BillTile name={"Coupons"} amount={orderInfo.offerDiscount} />
        <div className='dotted-border' ></div>
        <BillTile name={"Payable Amount"} amount={orderInfo.total } />
      </div>
        {/* <div style={{ marginBottom : "3rem" }} ></div>
        <footer>
          <div><hr /></div>
          <p>Flashpe, Wework Krishe Emerald, Kondapur, Hitech City, Hyderabad, India 500081</p>
        </footer> */}
    </div>
  )
}

export default OrderPage